import { Icon } from "../../../../../../components";

type Props = {
  "data-testid": string;
  onClick?: () => void;
};

const AddIcon = ({ "data-testid": dataTestId, onClick }: Props) => (
  <Icon
    data-testId={dataTestId}
    style={{ cursor: "pointer" }}
    name="add"
    onClick={onClick}
  />
);

export default AddIcon;
